export default __webpack_public_path__ + "static/media/Windows Photo Viewer Wallpaper.2dae29b0.png";